module.exports = __webpack_public_path__ + "static/media/Rectangle 12895.75213d66.png";